import { render, staticRenderFns } from "./InForm15.vue?vue&type=template&id=e42610cc&scoped=true&"
import script from "./InForm15.vue?vue&type=script&lang=js&"
export * from "./InForm15.vue?vue&type=script&lang=js&"
import style0 from "./InForm15.vue?vue&type=style&index=0&id=e42610cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42610cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VRow,VSimpleTable})
